import { SettingApi } from "lib/api";
import { ApiHelper, Http } from "lib/api/base";

import * as DataModel from "lib/data";


export class ContentManagementApi {

	public static getHomeContent = async (): Promise<DataModel.ContentHome | undefined> => {

		// Get Base Url
		const baseUrl = await SettingApi.getApiBaseUrl("web");

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/ContentHome`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const content: DataModel.ContentHome = await ApiHelper.parseResponseBody(response);

				return content;
			}

			// TODO: Handle Errors
		}

		// Return Nothing
		return undefined;
	}

	public static getContentSections = async (): Promise<DataModel.ContentSection[]> => {

		// Get Base Url
		const baseUrl = await SettingApi.getApiBaseUrl("web");

		// Check Base Url
		if (baseUrl) {

			// Configure Url
			const url: string = `${baseUrl}/ContentSection`;

			// Make Request
			const response: Response = await Http.httpGet(url, undefined);

			// Check Response
			if (response.ok) {

				// Parse Response Body
				const contentSections: DataModel.ContentSection[] = await ApiHelper.parseResponseBody(response);

				return contentSections;
			}

			// TODO: Handle Errors
		}

		// Return Empty List
		return [];
	}
}
